import { useId } from 'react'

export default function GlmLogo() {
  const clipId = useId()
  return (
    <svg width="16" height="16" viewBox="0 0 256 256">
      <g clipPath={`url(#${clipId})`}>
        <path d="M219.264 46.2363L105.891 209.763H33.8975L145.899 46.2363H219.264Z" fill="black" stroke="black" strokeWidth="2" />
        <path d="M152.243 188.12C159.734 188.068 169.577 188.081 179.375 188.123C189.172 188.165 198.921 188.235 206.221 188.294C209.87 188.324 212.907 188.35 215.032 188.37C216.023 188.379 216.816 188.386 217.38 188.392V209.748H124.365L139.809 188.416C139.963 188.399 140.165 188.381 140.417 188.364C141.052 188.322 141.952 188.285 143.084 188.253C145.345 188.189 148.497 188.146 152.243 188.12Z" fill="black" stroke="black" strokeWidth="2" />
        <path d="M128.898 46.2363L114.321 68.293H37.1719V46.2363H128.898Z" fill="black" stroke="black" strokeWidth="2" />
      </g>
      <defs>
        <clipPath id={clipId}>
          <rect width="192" height="165.526" fill="white" transform="translate(32 45.2363)" />
        </clipPath>
      </defs>
    </svg>
  )
}
